import { useSelector } from "react-redux"
import { Link, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import NavBar from "../components/navbar";
import Footer from "../components/footer";
import Contact from "../components/contact";
import Hero from "./components/hero";
import TriCards from "./components/triCards";
import BeforeAfter from "./components/beforeAfter";
import PageShell from "../components/pageShell"
import ZigZag from "./components/zigzag";
import { ButtonGroup } from "../components/basicUIComponents";
import { MetaTagHandler } from "../../../library/client/serverCallHandler";

const IndustrialPage = () => {

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>Industrial Drone Cleaning - Flyby Shine</title>
                        <meta name="description" content="Keep Your Property Safe and Hygienic with Our Expert Industrial Cleaning Services" />
                        <meta name="keywords" content="Drone Cleaning, Drone cleaning services, commercial drone cleaning, industrial drone cleaning, hygienic drone cleaning, expert drone cleaning services, safe drone cleaning, thorough drone cleaning, professional drone cleaning, reliable drone cleaning, top-quality drone cleaning, drone cleaning services, drone cleaning solutions, drone cleaning experts" />
                        <meta property="og:image" content="/assets/industrial.jpg" />
                    </>
                )}
            </MetaTagHandler>


            <PageShell>
                <Hero

                    title={'Industrial Cleaning'}
                    description={`Keep Your Property Safe and Hygienic with Our Expert Industrial Cleaning Services`}
                    banner={{ image: '/assets/industrial.jpg', alt: 'A cleaned industrial building' }}
                    callToAction={
                        <ButtonGroup>
                            <ButtonGroup.Button to={'https://fc.flybyshine.tech/request-work'} text={'Request an Estimate'} />
                            <ButtonGroup.Button to={'/commercial-industrial'} text={'All Services'} />
                        </ButtonGroup>
                    }

                />
                <TriCards>
                    <TriCards.Card
                        title={'Reach High Areas Safely'}
                        heading={{ image: '/assets/upwardIcon.svg', alt: 'about' }}
                        description={'With our state-of-the-art drone technology, we offer safe, efficient, and thorough cleaning solutions for multi-story buildings.'}

                    />
                    <TriCards.Card
                        title={'FAA Licensed Pilots'}
                        heading={{ image: '/assets/checkmark.svg', alt: 'about' }}
                        description={'Our team of FAA-licensed pilots brings exceptional expertise and reliability, ensuring top safety and quality standards in every project.'}
                    />
                    <TriCards.Card
                        title={'Faster Cleanings'}
                        heading={{ image: '/assets/boltIcon.svg', alt: 'about' }}
                        description={'Drones can clean large surface areas much faster than traditional methods, reducing the cleaning time.'}
                    />
                </TriCards>
                <BeforeAfter
                    title={"Before And After"}
                    description={"Our drones can reach high areas safely and efficiently, providing a thorough cleaning solution for industrial buildings."}
                    subTitle={"Industrial Cleaning"}
                    additionalDetails={
                        <div className="core-list">
                            <ul>
                                <li><i className="material-icons">check_circle_outline</i>Efficient & Fast Cleaning</li>
                                <li><i className="material-icons">check_circle_outline</i>Safe: No more ladders or platforms</li>
                                <li><i className="material-icons">check_circle_outline</i>Reach Inaccessible Areas</li>
                            </ul>
                        </div>
                    }
                    images={[{
                        firstImage: {
                            imageUrl: '/assets/industrialAfter.png',
                        },
                        secondImage: {
                            imageUrl: '/assets/industrialBefore.png',
                        }

                    }
                    ]}

                />

                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/solarpanel.jpg', alt: 'a clean solar panel' }}
                        title={'Minimized Risk of Property Damage'}
                        heading={{ image: '/assets/shieldIcon.svg', alt: 'protecting your property icon' }}
                        description={'Our drone cleaning technology allows for controlled pressure application tailored to different surfaces, minimizing the risk of damage to your valuable property.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/drone2a.png', alt: 'drone displayed' }}
                        title={'Customized Approach'}
                        heading={{ image: '/assets/flexible.svg', alt: 'flexibility about us icon' }}
                        description={'Our drones offer the flexibility to adapt to various surfaces and architectural styles, whether it’s high-rise office buildings, complex industrial sites, or delicate historical structures. We customize our approach to fit your specific requirements, ensuring optimal results for every job.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/watertower.jpg', alt: 'a clean water tower' }}
                        title={'Reduced Disruption to Operations'}
                        heading={{ image: '/assets/boltIcon.svg', alt: 'faster bolt icon' }}
                        description={'Our drone-assisted cleaning services are faster and more efficient, allowing us to clean your property without disrupting your daily operations. This means less interference with your employees, customers, or tenants, keeping your business running smoothly.'}
                    />
                </ZigZag>
                <Contact />
            </PageShell>
            <style>
                {
                    `
                    .zigzag {
                    margin-top: 150px
                    }
                    `
                }
            </style>

        </>
    )
}

export default IndustrialPage
